import {createSlice} from '@reduxjs/toolkit'



const solicitorSlice = createSlice({
    name:'solicitor',
     initialState: {
    list: [],
  },
    reducers:{
     setSolicitor: (state, action) => {
          state.list = action.payload;
        },
      addSolicitors: (state, action) => {
        console.log(state ,action,'action@123')
        state.list.push(action.payload);
    },

      viewSolicitor: (state, action) => {
      const solicitor = state.list.find(item => item._id === action.payload);
      state.selectedSolicitor = solicitor || null; 
    },
    updateSolicitor: (state, action) => {
      const index = state.list.findIndex(customer => customer._id === action.payload._id);
      if (index !== -1) {
        state.list[index] = action.payload;
      }
    },
 
        deleteSolicitor: (state, action) => {
        state.list = state.list.filter(customer => customer._id !== action.payload);
        }

    },
});

export const {setSolicitor , addSolicitors , updateSolicitor , deleteSolicitor} = solicitorSlice.actions;
export default solicitorSlice.reducer;